/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import {
  FormLabel,
} from '@one-thd/sui-atomic-components';
import {
  Input,
  ErrorMessage,
} from './styles';

function InputRoomName(props) {
  const {
    errorText,
    inputName,
    placeholder,
    showError,
    forwardedRef,
    label,
    id,
    value,
  } = props;

  const customRoomRef = (el) => {
    if (el) {
      forwardedRef.current[inputName] = el;
    }
  };

  return (
    <>
      <FormLabel htmlFor={id}>{label}</FormLabel>
      <Input
        id={id}
        data-testid={id}
        maxLength="25"
        ref={customRoomRef}
        minLength="1"
        type="text"
        name={inputName}
        placeholder={placeholder}
        defaultValue={value}
      />
      <ErrorMessage showError={showError}>{errorText}</ErrorMessage>
    </>
  );
}

InputRoomName.propTypes = {
  errorText: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  inputName: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  showError: PropTypes.bool.isRequired,
  id: PropTypes.string,
  value: PropTypes.string,
  forwardedRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ })
  ]),

};

InputRoomName.defaultProps = {
  id: 'id',
  value: undefined,
  forwardedRef: 'ref',
};
export default InputRoomName;
